module.exports = __webpack_public_path__ + "img/mg.00850c90.jpg";